import React from 'react';
import { findDOMNode } from 'react-dom';
import './checked-select.less';

var tagStyle = {
    chosenWrapper: {
        border: '1px solid #d1d4d7',
        display: 'flex',
        alignItems: 'center',
        paddingTop: 2,
        flex: 1,
        fontSize: 14,
        background: '#fff',
        color: '#3d3f42',
        height: 35,
        borderRadius: 4,
        WebkitUserSelect: 'none',
        paddingLeft: 10
    },
    dropdownWrapper: {
        borderLeft: '1px solid #d1d4d7',
        borderRight: '1px solid #d1d4d7',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        background: '#fff',
        position: 'absolute',
        left: 0,
        right: 0,
        zIndex: 9
    },
    dropdownItem: {
        fontSize: 14,
        height: 40,
        paddingLeft: 15,
        display: 'flex',
        alignItems: 'center',
        borderBottom: '1px solid #d1d4d7',
        WebkitUserSelect: 'none',
        cursor: 'pointer'
    }
};

export default class TagSelect extends React.Component {
    static defaultProps = {
      placeholder: 'Choose Tag(s)'
    };
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        };

        this.handleDocumentClick = this.handleDocumentClick.bind(this);
    }
    toggleDropdownOpen() {
        this.setState({isOpen: !this.state.isOpen});
    }
    componentDidMount() {
        document.addEventListener('click', this.handleDocumentClick, true);
    }
    componentWillUnmount() {
        document.removeEventListener('click', this.handleDocumentClick, true);
    }
    handleDocumentClick(e) {
        const domNode = findDOMNode(this);

        if (!domNode.contains(e.target)) {
            this.setState({isOpen: false});
        }
    }
    changeSelected(isSelected, tagId) {
        var tagsSelected = this.props.tagsSelected.filter(t => t != tagId);
        if(! isSelected) {
            tagsSelected.push(tagId);
        }

        this.props.onChange(tagsSelected);
    }
    clearSelected(isSelected, tagId) {
        this.props.onChange([]);
    }
    render() {
        var { isOpen } = this.state;
        var { tags, tagsSelected, placeholder } = this.props;

        if(tags.length) {
            var tagsStr = tagsSelected.sort().map(tagId =>
                tags.find(t => t.id == tagId).name
            ).join(", ");
        } else {
            var tagsStr = "";
        }

        return (
            <div style={{flex: 1, position: 'relative'}}>
                <div onClick={this.toggleDropdownOpen.bind(this)} style={tagStyle.chosenWrapper}>
                    {!! tagsStr &&
                    <div style={{display: 'flex', flex: 1}}>
                        <span style={{flex: 1}}>{tagsStr}</span>
                        <span onClick={this.clearSelected.bind(this)} style={{color: '#999', marginRight: 10, cursor: 'pointer'}}>x</span>
                    </div>
                    }

                    {!isOpen && ! tagsStr &&
                    <span>{placeholder}</span>
                    }
                </div>
                { isOpen &&
                <div style={tagStyle.dropdownWrapper}>
                    {tags.map(t => {
                        var isSelected = tagsSelected.includes(t.id);
                        var background = isSelected ? '#f7f8fb' : '#fff';
                        return (
                            <div key={t.id}
                                 className="checked-select-dropdown-item"
                                 onClick={this.changeSelected.bind(this, isSelected, t.id)}
                                 style={{...tagStyle.dropdownItem, background}}>
                                <input type="checkbox" readOnly checked={isSelected} style={{marginRight: 10}} /> <span>{t.name}</span>
                            </div>
                        );
                    })}
                </div>
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/checked-select/CheckedSelect.js